import React, { Component } from "react"
import { withTranslation } from "react-i18next";
import ConsentList from '../ConsentList/ConsentList.js';
import './Consent.scss';
import UnsubscribePopUp from "../UnsubscribePopUp/UnsubscribePopUp.js";
import { textBreak } from "../../utils/textBreak.js";
import "../../scss/buttons.scss";
import i18n from "../../i18n";
import globalConfig from '../../config/global/config.json';
class Consent extends Component {

  state = {
    popup: false
  }

  removePopUp = () => {
    this.setState({ popup: false })
  }

  handleUpdate = () => {
    const enableUnsubscribe = i18n.exists("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") ? i18n.t("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") : globalConfig["SET_ENABLE_UNSUBSCRIBE_ALL"];
    if (this.props.consents[this.props.consents.length - 1].isChecked && enableUnsubscribe) {
      this.setState({
        ...this.state,
        popup: true
      })
    } else {
      this.props.handleSubmit()
    }
  }

  render() {
    const { t, consents, handleChange } = this.props;
    return (
      <div className="container consent-container px-3 pt-3">
        {this.state.popup ? <UnsubscribePopUp removePopUp={this.removePopUp} handleSubmit={this.props.handleSubmit}/> : null}
        {textBreak(t("pageIntro1"))}
        {textBreak(t("pageIntro2"))}
        <div className="container mt-1 px-0">
          <form>
            <ConsentList consents={consents} handleChange={handleChange} />
          </form>
        </div>
        <hr />
        {textBreak(t("pageText#processing"))}
        {textBreak(t("pageText#privacy"))}
        {textBreak(t("pageText#legalNotice"))}
        <div className="text-end">
          <button className="button" title={t("updateBtn#title")} onClick={this.handleUpdate}>{t("updateBtn#label")}</button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Consent);